import { OrgProductsTranslations } from "#i18n/translations/pt-BR/org/products";
import { ORG_PRODUCTS_TAB_EN_US } from "./products-tab";
import { ORG_PRODUCTS_CATEGORIES_EN_US } from "./categories";

export const ORG_PRODUCTS_EN_US: OrgProductsTranslations = {
	tabs: {
		productsTab: ORG_PRODUCTS_TAB_EN_US,
		categories: ORG_PRODUCTS_CATEGORIES_EN_US,
		generalStock: "General stock",
	},
	functions: {
		modal: {
			sheet: {
				inventory: "inventory",
				columns: {
					id: "Product Id",
					name: "Name",
					category: "Category",
					type: "Product type",
					hasAlcohol: "Does it contain alcohol?",
					fiscalCode: "SKU",
					fiscalNcm: "Fiscal - NCM",
				},
			},
		},
	},
	emptyList: "No products found",
};
